import { APIResponseType } from 'app/apiService/types';
import apiService from 'app/apiService';
import { UnsoldMetricsResponse } from '../types';

import unsoldMetricsMockData from './unsold_metrics_mock_data.json';

interface DealerMetricsMock {
  dealer_id: string;
  dealer_name: string;
  metrics: UnsoldMetricsResponse['metrics'];
}

class UnsoldApiService {
  static ENDPOINT = 'api/v2/unsold';

  static async getMetrics(dealer_id: string): Promise<APIResponseType<UnsoldMetricsResponse>> {
    try {
      // For now, return mock data from JSON based on dealer_id
      // TODO: Replace with actual API call when backend is ready
      // const response = await apiService.get<APIResponseType<UnsoldMetricsResponse>>(
      //   `${this.ENDPOINT}/metrics`,
      //   { params: { dealer_id } }
      // );
      // return response;

      const data = unsoldMetricsMockData as DealerMetricsMock[];
      const dealerData = data.find((d) => d.dealer_id === dealer_id);

      const metrics: UnsoldMetricsResponse = {
        metrics: dealerData?.metrics ?? [],
      };

      return {
        body: metrics,
        message: dealerData
          ? 'Unsold metrics retrieved successfully'
          : 'No metrics found for the selected dealer',
        statusCode: 200,
      };
    } catch (error) {
      console.error('Error fetching unsold metrics:', error);
      throw error;
    }
  }
}

export default UnsoldApiService;

